import apiClient from '../client';
import { ApiResponse } from '../types/common.types';
import {
  PaymentRecordRequest,
  Payment,
  PaymentVerificationRequest,
  PaymentReversalRequest,
  MpesaSTKPushRequest,
  MpesaSTKPushResponse,
  MpesaQueryRequest,
  MpesaQueryResponse,
} from '../types/payment.types';

/**
 * Payment API endpoints
 */
export const paymentsApi = {
  /**
   * Record manual payment
   */
  record: async (data: PaymentRecordRequest): Promise<{ paymentId: string; payment: Payment }> => {
    const response = await apiClient.post<ApiResponse<{ paymentId: string; payment: Payment }>>(
      '/payments/record',
      data
    );
    if (!response.data.data) {
      throw new Error('No data received from server');
    }
    return response.data.data;
  },

  /**
   * Verify payment
   */
  verify: async (data: PaymentVerificationRequest): Promise<{ success: boolean }> => {
    const response = await apiClient.post<ApiResponse>('/payments/verify', data);
    return { success: response.data.success };
  },

  /**
   * Get payment details
   */
  getById: async (paymentId: string): Promise<Payment> => {
    const response = await apiClient.get<ApiResponse<{ payment: Payment }>>(`/payments/${paymentId}`);
    if (!response.data.data) {
      throw new Error('No data received from server');
    }
    return response.data.data.payment;
  },

  /**
   * Get loan payments
   */
  getByLoan: async (loanId: string): Promise<Payment[]> => {
    const response = await apiClient.get<ApiResponse<{ payments: Payment[] }>>(`/payments/loan/${loanId}`);
    if (!response.data.data) {
      throw new Error('No data received from server');
    }
    return response.data.data.payments;
  },

  /**
   * Reverse payment (Admin only)
   */
  reverse: async (data: PaymentReversalRequest): Promise<{ success: boolean }> => {
    const response = await apiClient.post<ApiResponse>('/payments/reverse', data);
    return { success: response.data.success };
  },

  // ==================== M-PESA ====================

  /**
   * Initiate M-Pesa STK Push
   */
  mpesaSTKPush: async (data: MpesaSTKPushRequest): Promise<MpesaSTKPushResponse> => {
    const response = await apiClient.post<MpesaSTKPushResponse>('/mpesa/stkpush', data);
    return response.data;
  },

  /**
   * Query M-Pesa transaction status
   */
  mpesaQuery: async (data: MpesaQueryRequest): Promise<MpesaQueryResponse> => {
    const response = await apiClient.post<MpesaQueryResponse>('/mpesa/query', data);
    return response.data;
  },
};
